import { UseFormReturn } from "react-hook-form"
import { MailIcon } from "../../../../../ui/icons/mail"
import { XCircleIcon } from "../../../../../ui/icons/xCircle"
import Button from "../../../../../ui/molecules/button"
import Input from "../../../../../ui/molecules/input"
import { UpdateCompanyFormValues } from "./validation"

export function CompanyEmails({ form }: { form: UseFormReturn<UpdateCompanyFormValues> }) {
    const emails = form.watch("emails") || ['']
    const errors = form.formState.errors.emails

    const updateEmail = (index: number, value: string) => {
        const updatedEmails = [...emails]
        updatedEmails[index] = value
        form.setValue("emails", updatedEmails, { shouldValidate: true })
    }

    const removeEmail = (index: number) => {
        const updatedEmails = emails.filter((_, i) => i !== index)
        if (updatedEmails.length === 0) {
            form.setValue("emails", [''], { shouldValidate: true })
        } else {
            form.setValue("emails", updatedEmails, { shouldValidate: true })
        }
    }

    const addEmail = () => {
        form.setValue("emails", [...emails, ''], { shouldValidate: true })
    }

    return (
        <>
            {
                emails.map((email, index) => {
                    const fieldError = Array.isArray(errors) ? errors[index] : undefined
                    return (
                        <div key={index} className="flex items-start">
                            <Input
                                onChangeText={(text) => {
                                    updateEmail(index, text)
                                }}
                                label="Email"
                                error={!!fieldError || (emails.length === 0)}
                                value={email === null ? '' : email}
                                supportingText={fieldError?.message || ''}
                                startIcon={<MailIcon color={""} size={0} />}
                            />
                            <div className="h-[60px] pt-5">
                                <div className="h-10 flex items-center justify-center">
                                    <Button
                                        size={"sm"}
                                        iconPosition={"only"}
                                        icon={<XCircleIcon color={""} size={0} />}
                                        variant={"ghost"}
                                        color={"blue"}
                                        onClick={() => {
                                            removeEmail(index)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )
                })
            }
            <div className="flex items-end justify-end">
                <Button
                    size={"sm"}
                    iconPosition={"off"}
                    variant={"link"}
                    color={"blue"}
                    label="Aggiungi email"
                    onClick={() => {
                        addEmail()
                    }}
                />
            </div>
        </>
    )
}